











































































































































































import {Vue, Component, Prop} from 'vue-property-decorator'
import NetworkTag from '@/components/NetworkTag.vue'
import {MyWalletCacheAssist} from '@/helpers/MyWalletCacheAssist'
import {$} from '@/facade'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {NetworkNamespace} from '@/enums/NetworkNamespace'

@Component({
  components: {NetworkTag},
  computed: {
    $() {
      return $
    },
  },
})
export default class MyWalletChooseWallet extends MixinScreenSize {
  @Prop({type: MyWalletCacheAssist, required: true})
  cacheAssist!: MyWalletCacheAssist

  get walletSelected() {
    return this.cacheAssist.currentWallet.isWatchWallet
      ? 'WatchOnly'
      : this.cacheAssist.currentWallet.network
  }

  refreshData() {
    this.cacheAssist.refreshData()
  }

  async onClickWatchOnlyWallet() {
    let address

    if ($.watchWallet.address) {
      address = $.watchWallet.address
    } else if ($.walletAdapter.n3Address) {
      address = $.walletAdapter.n3Address
    } else if ($.walletAdapter.xAddress) {
      address = $.walletAdapter.xAddress
    }

    if (!address) {
      $.modal.open('connectWalletModal')
      return
    }

    await this.cacheAssist.populateWatchWallet(address)
  }

  async onClickN3Wallet() {
    if (!$.walletAdapter.n3Address) {
      $.modal.open('connectWalletModal', {
        networkNamespace: NetworkNamespace.n3,
      })
      return
    }

    await this.cacheAssist.populateWallet($.walletAdapter.n3Address)
  }

  async onClickXWallet() {
    if (!$.walletAdapter.xAddress) {
      $.modal.open('connectWalletModal', {
        networkNamespace: NetworkNamespace.x,
      })

      return
    }

    await this.cacheAssist.populateWallet($.walletAdapter.xAddress)
  }
}
